import { render } from "./App.vue?vue&type=template&id=d6be5bd6"
const script = {}

import "./App.vue?vue&type=style&index=0&id=d6be5bd6&lang=css"

import exportComponent from "/Users/wangwangao/Desktop/test项目/vue3-TS-vant-env/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__